<template>
  <Carousel 
    v-model="carouselIndex" 
    :loop="loop" 
    :dots="dots" 
    :arrow="arrow"  
    :autoplay="autoplay" 
    :autoplay-speed="autoplayspeed"
  >
    <CarouselItem 
      v-for="(item,index) in carouselItems"
      :key="`activity-carousel-${index}`"
    >
      <router-link
        :to="{ name: item.pathName }"
      >
      <div 
        class="carousel-item"
        :style="{ backgroundImage: `url(${item.img})`,height: `280px` }"
      > 
      </div>
      </router-link>
    </CarouselItem>
  </Carousel>
</template>

<script>
  import { Carousel, CarouselItem } from 'iview';

  export default {
    components: {
      Carousel,
      CarouselItem
    },
    props: {
      dots: {
        type: String,
        default: 'none'
      },
      loop: {
        type: Boolean,
        default: false
      },
      autoplay:{
        type: Boolean,
        default: false
      },
      autoplayspeed:{
        type:Number,
       default: 2000
    },
      arrow: {
        type: String,
        default: 'always'
      },
      carouselItems: {
        type: Array,
        default: () => {}
      }
    },
    data() {
      return {
        carouselIndex: 0,
      };
    }
  };
</script>
